module.exports = __webpack_public_path__ + "static/instagram-eefd8dc9339309e8fa5c73509c1c8b86.png";